module.exports = __webpack_public_path__ + "media/images/village/career-camp-2022/location-bg-350a40ad364f3def168b523596ad7ac8.png";